import React, { useEffect, useState } from "react";
import "./AndajPatrak.css";

const AndajPatrak = () => {
  const [records, setRecords] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [info, setInfo] = useState({
    gram: "भलेवाडी",
    taluka: "कारंजा (घा)",
    district: "वर्धा",
    year: "2025-2026",
  });

  const [form, setForm] = useState({
    type: "उत्पन्न",
    head: "",
    previousAmount: "",
    currentAmount: "",
    estimatedAmount: "",
    remark: "",
  });

  useEffect(() => {
    const saved = localStorage.getItem("andajPatrakRecords");
    setRecords(saved ? JSON.parse(saved) : []);
  }, []);

  useEffect(() => {
    localStorage.setItem("andajPatrakRecords", JSON.stringify(records));
  }, [records]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setForm({
      type: "उत्पन्न",
      head: "",
      previousAmount: "",
      currentAmount: "",
      estimatedAmount: "",
      remark: "",
    });
    setEditingId(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.head || !form.estimatedAmount) {
      alert("लेखा शिर्षक आणि अंदाजित रक्कम भरा");
      return;
    }

    const newRecord = {
      id: editingId || Date.now(),
      ...form,
    };

    if (editingId) {
      setRecords(records.map((r) => (r.id === editingId ? newRecord : r)));
    } else {
      setRecords([newRecord, ...records]);
    }

    resetForm();
  };

  const handleEdit = (record) => {
    setForm(record);
    setEditingId(record.id);
  };

  const handleDelete = (id) => {
    if (window.confirm("ही नोंद delete करायची आहे का?")) {
      setRecords(records.filter((r) => r.id !== id));
    }
  };

  const incomeRecords = records.filter((r) => r.type === "उत्पन्न");
  const expenseRecords = records.filter((r) => r.type === "खर्च");

  const totalIncome = incomeRecords.reduce(
    (sum, r) => sum + Number(r.estimatedAmount || 0),
    0
  );

  const totalExpense = expenseRecords.reduce(
    (sum, r) => sum + Number(r.estimatedAmount || 0),
    0
  );

  const balance = totalIncome - totalExpense;

  return (
    <div className="budget-page">
      <div className="budget-box">

        <div className="budget-actions no-print">
          <button onClick={() => window.print()}>🖨️ प्रिंट</button>
        </div>

        <div className="budget-header">
          <h2>ग्रामपंचायत अंदाजपत्रक</h2>
          <h3>उत्पन्न व खर्च अंदाजपत्रक</h3>

          <div className="budget-info no-print">
            <input
              value={info.gram}
              onChange={(e) => setInfo({ ...info, gram: e.target.value })}
              placeholder="ग्रामपंचायत"
            />
            <input
              value={info.taluka}
              onChange={(e) => setInfo({ ...info, taluka: e.target.value })}
              placeholder="तालुका"
            />
            <input
              value={info.district}
              onChange={(e) => setInfo({ ...info, district: e.target.value })}
              placeholder="जिल्हा"
            />
            <input
              value={info.year}
              onChange={(e) => setInfo({ ...info, year: e.target.value })}
              placeholder="वर्ष"
            />
          </div>

          <p className="print-info">
            ग्रामपंचायत: {info.gram} | ता. {info.taluka} | जि. {info.district} | वर्ष: {info.year}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="budget-form no-print">
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="उत्पन्न">उत्पन्न</option>
            <option value="खर्च">खर्च</option>
          </select>

          <input
            name="head"
            value={form.head}
            onChange={handleChange}
            placeholder="लेखा शिर्षक"
          />

          <input
            type="number"
            name="previousAmount"
            value={form.previousAmount}
            onChange={handleChange}
            placeholder="मागील वर्षाची रक्कम"
          />

          <input
            type="number"
            name="currentAmount"
            value={form.currentAmount}
            onChange={handleChange}
            placeholder="चालू वर्षाची रक्कम"
          />

          <input
            type="number"
            name="estimatedAmount"
            value={form.estimatedAmount}
            onChange={handleChange}
            placeholder="पुढील वर्षाचा अंदाज"
          />

          <input
            name="remark"
            value={form.remark}
            onChange={handleChange}
            placeholder="शेरा"
          />

          <button type="submit">
            {editingId ? "अपडेट करा" : "नोंद जोडा"}
          </button>

          {editingId && (
            <button type="button" onClick={resetForm} className="cancel-btn">
              रद्द करा
            </button>
          )}
        </form>

        <div className="summary-cards">
          <div>
            <h4>एकूण उत्पन्न</h4>
            <p>₹ {totalIncome}</p>
          </div>
          <div>
            <h4>एकूण खर्च</h4>
            <p>₹ {totalExpense}</p>
          </div>
          <div>
            <h4>शिल्लक</h4>
            <p className={balance >= 0 ? "green" : "red"}>₹ {balance}</p>
          </div>
        </div>

        <h3 className="section-title">उत्पन्न विभाग</h3>
        <BudgetTable records={incomeRecords} onEdit={handleEdit} onDelete={handleDelete} />

        <h3 className="section-title">खर्च विभाग</h3>
        <BudgetTable records={expenseRecords} onEdit={handleEdit} onDelete={handleDelete} />

        <div className="signature">
          <p>सरपंच सही</p>
          <p>ग्रामसेवक सही</p>
        </div>
      </div>
    </div>
  );
};

const BudgetTable = ({ records, onEdit, onDelete }) => {
  return (
    <table className="budget-table">
      <thead>
        <tr>
          <th>अ.क्र.</th>
          <th>लेखा शिर्षक</th>
          <th>मागील वर्ष</th>
          <th>चालू वर्ष</th>
          <th>पुढील वर्षाचा अंदाज</th>
          <th>शेरा</th>
          <th className="no-print">क्रिया</th>
        </tr>
      </thead>

      <tbody>
        {records.length === 0 ? (
          <tr>
            <td colSpan="7">नोंद उपलब्ध नाही</td>
          </tr>
        ) : (
          records.map((r, index) => (
            <tr key={r.id}>
              <td>{index + 1}</td>
              <td>{r.head}</td>
              <td>₹ {r.previousAmount || 0}</td>
              <td>₹ {r.currentAmount || 0}</td>
              <td>₹ {r.estimatedAmount || 0}</td>
              <td>{r.remark}</td>
              <td className="no-print">
                <button onClick={() => onEdit(r)}>Edit</button>
                <button onClick={() => onDelete(r.id)}>Delete</button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default AndajPatrak;